import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { LoanService } from "../../shared/loan.service";
import { environment } from '../../../../environments/environment';
import { Loan } from "../loan";
import { Savings } from "../../../savings/shared/savings.model";
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';

@Injectable({
  providedIn: 'root'
})

export class PrintpassbookService {

  // public selectedLoan: Loan;
  public selectedSavings: Savings;
  constructor(private httpClient: HttpClient,
    private loanService: LoanService, public datePipe: DatePipe,) { }

  getBaseUrl() {
    return environment.baseUrl;
  }

  GenerateReport(rptSearchData: any) {

    this.FetchPassbook(rptSearchData)
      .toPromise()
      .then(data => {

        if (data.length > 0) {
          if (data[0].TransactionDate != undefined) {
            // console.log(data.LoanPayDate);
            // this.ReportGenerateList(data, this.datePipe);
            this.ReportGenerateListHtml(data, this.datePipe);
          }
          else {
            console.log('Passbook not generated, Initial transaction has not done!');
          }
        }
        else {
          console.log('data not found!');
        }
      })
      .catch(err => { console.log(err) });
  }

  FetchPassbook(rptSearchData: any) {

    this.selectedSavings = new Savings();
    this.selectedSavings.Id = rptSearchData.SavingsId;
    this.selectedSavings.ReportName = rptSearchData.ReportName;
    this.selectedSavings.ToDate = rptSearchData.LoanToDate;
    this.selectedSavings.BranchId = rptSearchData.BranchId;
    this.selectedSavings.CentreId = rptSearchData.CentreId;

    this.selectedSavings.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedSavings.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedSavings.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedSavings.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedSavings;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Loan/Report', body, { headers: headers });
  }

  //--------------------Not using now------------------------------
  // // Printing the documents as a lists.  
  // ReportGenerateList(CollectionList: any, datePipe: DatePipe) {

  //   var generateData = function (CollectionList) {

  //     var result = [];
  //     var itemData = [{}];
  //     // let todayDate = new Date(); 
  //     // console.log(datePipe.transform(todayDate, 'yyyy-MM-dd'));
  //     for (var i = 0; i < CollectionList.length; i += 1) {

  //       itemData[i] = {

  //       Id: CollectionList[i].Id,  
  //       'No.': CollectionList[i].Id.toString(),
  //       'Date': datePipe.transform(CollectionList[i].TransactionDate.toString(), 'dd-MM-yyyy').toString(),
  //       'Loan Payment': CollectionList[i].CollectionAmount.toString(),
  //       'Savings Payment': CollectionList[i].PrincipleAmount.toString(),
  //       'Interest': CollectionList[i].InterestAmount.toString(),
  //       // 'Savings Balance': CollectionList[i].PreviousSavingsBalance.toString(), // datePipe.transform(CollectionList[i].ApplicationDate, 'dd-MM-yyyy').toString(),
  //       'Withdraw Amount': CollectionList[i].WithdrawalAmount.toString(),
  //       'Total Payment': CollectionList[i].PaidAmount.toString(),
  //       'Manager Name': String(' '),
  //       'Sign': String(' '),
  //       };
  //     }

  //     for (var i = 0; i < CollectionList.length; i += 1) {
  //       itemData[i]['Id'] = (i + 1).toString();
  //       result.push(Object.assign({}, itemData[i]));
  //     }

  //     return result;
  //   };


  //   function createHeaders(HeaderName) {

  //     var HeaderResult = [];
  //     for (var i = 0; i < HeaderName.length; i += 1) {
  //       HeaderResult.push({
  //         id: HeaderName[i],
  //         name: HeaderName[i],
  //         prompt: HeaderName[i],
  //         width: 87,
  //         align: "left",
  //         padding: 2,
  //       });
  //     }
  //     return HeaderResult;
  //   }

  //   var headers = createHeaders([
  //     "No.",
  //     "Date",
  //     "Loan Payment",
  //     "Savings Payment",
  //     "Interest",
  //     "Withdraw Amount",
  //     "Total Payment",
  //     "Manager Name",
  //     "Sign"
  //   ]);

  //   // Document of 210mm wide and 297mm high
  //   // new jsPDF('p', 'mm', [297, 210]);
  //   // // Document of 297mm wide and 210mm high
  //   // new jsPDF('l', 'mm', [297, 210]);
  //   // // Document of 5 inch width and 3 inch high
  //   // new jsPDF('l', 'in', [3, 5]);

  //   // let pdf = new jsPDF('l', 'pt', 'legal');    
  //   // let pdf = new jsPDF('l', 'pt', 'letter');
  //   let pdf = new jsPDF('p', 'pt', 'A4');
  //   //   let pdf = new JsPDF(  
  //   //     Orientation, // Landscape or Portrait     
  //   //     unit, // mm, cm, in     
  //   //     format // A2, A4 etc  
  //   // );  

  //   pdf.setProperties({
  //     title: 'Loan Passbook',
  //     subject: 'Info about PDF',
  //     author: 'PDFAuthor',
  //     keywords: 'generated, javascript, web 2.0, ajax',
  //     creator: 'SRI'
  //   });

  //   let todayDate = new Date();

  //   // Top HEADER
  //   pdf.setTextColor(0, 0, 0);
  //   pdf.setFontSize(14);
  //   pdf.setFont('arial', 'normal');
  //   pdf.text("Society For Rural Improvements", 210, 20);  // 40 is the height
  //   pdf.text("Passbook", 255, 40);
  //   pdf.text("Statement on  " + datePipe.transform(todayDate, 'dd-MM-yyyy'), 225, 60);
  //   pdf.setLineWidth(1);
  //   pdf.line(5, 70, 590, 70)
  //   // Top HEADER END 

  //   // Second Top HEADER
  //   pdf.setFontSize(10);
  //   pdf.setFont('arial', 'normal');
  //   pdf.text("CUSTOMER: " + CollectionList[0].CustomerName.toString(), 35, 80);
  //   pdf.text("BRANCH	: " + CollectionList[0].CustomerBranchName.toString(), 35, 95);
  //   pdf.text("CENTRE	: " + CollectionList[0].CentreName.toString(), 35, 110);
  //   pdf.text("PRE. SAVINGS AMOUNT : " + CollectionList[0].PreSavingsAmount.toString(), 35, 125);
  //   pdf.text("LOAN AMOUNT:" + CollectionList[0].LoanAmount.toString(), 35, 140);
  //   pdf.text("REPAYMENT AMOUNT :" + CollectionList[0].TotalRepaymentAmount.toString(), 35, 155);

  //   // pdf.text("LOAN/ SAVINGS NO.:" + CollectionList[0].Id , 375, 120) ;
  //   pdf.text("LOAN/ SAVINGS NO.:" + CollectionList[1].LoanNumber + " / " + CollectionList[0].SavingsNumber, 325, 80) ;
  //   pdf.text("LOAN/ SAVINGS DATE :" + datePipe.transform(CollectionList[0].LoanApprovedDate, 'dd-MM-yyyy').toString() +" / " +
  //   datePipe.transform(CollectionList[0].LoanApprovedDate, 'dd-MM-yyyy'), 325, 95);
  //   // pdf.text("LOAN AMOUNT:" + CollectionList[0].LoanAmount.toString(), 325, 110);
  //   // pdf.text("REPAYMENT AMOUNT :" + CollectionList[0].TotalRepaymentAmount.toString(), 325, 125);
  //   pdf.text("TOTAL LOAN PAID: " + CollectionList[0].TotalLoanAmount.toString(), 325, 110);
  //   pdf.text("TOTAL SAVINGS PAID: " + CollectionList[0].TotalSavingsAmount.toString(), 325, 125);
  //   pdf.text("TOTAL INTEREST RECIEVED: " + CollectionList[0].TotalInterestAmount.toString(), 325, 140);
  //   pdf.text("TOTAL WITHDRAWAL AMOUNT: " + CollectionList[0].TotalWithdrawalAmount.toString(), 325, 155);

  //   pdf.line(5, 165, 590, 165)   // x-axis, -x-axix,  y-axis  , -y-axix
  //   // Top HEADER END 

  //   // var doc = new jsPDF({ putOnlyUsedFonts: true, orientation: "landscape" });
  //   // doc.table(1, 1, generateData(100), headers, { autoSize: true });

  //   // Body
  //   pdf.table(5, 170, generateData(CollectionList), headers, { autoSize: false });
  //   pdf.output('dataurlnewwindow');
  //   // Body End
  // }

  ReportGenerateListHtml(CollectionList, datePipe: DatePipe) {

    console.log(CollectionList)
    let pdf = new jsPDF('p', 'pt', 'A4');

    var img = new Image()
    img.src = '../../assets/appimages/SRI.png'
    // var options = {orientation: 'p', unit: 'mm', format: custom};
    // var doc = new jsPDF(options);
    pdf.addImage(img, 'png', 250, 80, 50, 50);
    let todayDate = new Date();

    // Top HEADER
    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(14);
    pdf.setFont('arial', 'normal');
    pdf.text("Society For Rural Improvements", 210, 20);  // 40 is the height
    pdf.text("Passbook", 255, 40);
    pdf.text("Statement on  " + datePipe.transform(todayDate, 'dd-MM-yyyy'), 225, 60);
    pdf.setLineWidth(1);
    pdf.line(5, 70, 590, 70)
    // Top HEADER END 

    // Second Top HEADER
    pdf.setFontSize(10);
    pdf.setFont('arial', 'normal');
    pdf.text("CUSTOMER: " + CollectionList[0].CustomerName.toString(), 35, 80);
    pdf.text("BRANCH	: " + CollectionList[0].CustomerBranchName.toString(), 35, 95);
    pdf.text("CENTRE	: " + CollectionList[0].CentreName.toString(), 35, 110);
    pdf.text("PRE. SAVINGS AMOUNT : " + CollectionList[0].PreSavingsAmount.toString(), 35, 125);
    pdf.text("LOAN AMOUNT:" + CollectionList[0].LoanAmount.toString(), 35, 140);
    pdf.text("REPAYMENT AMOUNT :" + CollectionList[0].TotalRepaymentAmount.toString(), 35, 155);

    // pdf.text("LOAN/ SAVINGS NO.:" + CollectionList[0].Id , 375, 120) ;
    pdf.text("LOAN/ SAVINGS NO.:" + CollectionList[0].LoanNumber + " / " + CollectionList[0].SavingsNumber, 325, 80);
    pdf.text("LOAN/ SAVINGS DATE :" + datePipe.transform(CollectionList[0].LoanApprovedDate, 'dd-MM-yyyy').toString() + " / " +
      datePipe.transform(CollectionList[0].LoanApprovedDate, 'dd-MM-yyyy'), 325, 95);
    // pdf.text("LOAN AMOUNT:" + CollectionList[0].LoanAmount.toString(), 325, 110);
    // pdf.text("REPAYMENT AMOUNT :" + CollectionList[0].TotalRepaymentAmount.toString(), 325, 125);
    pdf.text("TOTAL LOAN PAID: " + CollectionList[0].TotalLoanAmount.toString(), 325, 110);
    pdf.text("TOTAL SAVINGS PAID: " + CollectionList[0].TotalSavingsAmount.toString(), 325, 125);
    pdf.text("TOTAL INTEREST RECIEVED: " + CollectionList[0].TotalInterestAmount.toString(), 325, 140);
    pdf.text("TOTAL WITHDRAWAL AMOUNT: " + CollectionList[0].TotalWithdrawalAmount.toString(), 325, 155);

    pdf.line(5, 165, 590, 165)   // x-axis, -x-axix,  y-axis  , -y-axix
    // Top HEADER END 

    // list item to json array
    var itemData = [];
    for (var i = 0; i < CollectionList.length; i += 1) {
      itemData[i] = {

        'No': (i + 1).toString(),
        'Date': datePipe.transform(CollectionList[i].TransactionDate.toString(), 'dd-MM-yyyy').toString(),
        'LoanPayment': CollectionList[i].CollectionAmount.toString(),
        'SavingsPayment': CollectionList[i].PrincipleAmount.toString(),
        'Interest': CollectionList[i].InterestAmount.toString(),
        'WithdrawAmount': CollectionList[i].WithdrawalAmount.toString(),
        'TotalPayment': CollectionList[i].PaidAmount.toString(),
        'ManagerName': String(' '),
        'Sign': String(' '),
      };
    }

    var rows = [];
    // convert json array to Array
    itemData.forEach((element, index, array) => {
      rows.push([element.No, element.Date, element.LoanPayment, element.SavingsPayment,
      element.Interest, element.WithdrawAmount, element.TotalPayment,
      element.ManagerName, element.Sign
      ])
    });

    var columns = [
      { title: "No", dataKey: "No" },
      { title: "Date", dataKey: "Date" },
      { title: "Loan Payment", dataKey: "LoanPayment" },
      { title: "Savings Payment", dataKey: "SavingsPayment" },
      { title: "Interest", dataKey: "Interest" },
      { title: "Withdraw Amount", dataKey: "WithdrawAmount" },
      { title: "Total Payment", dataKey: "TotalPayment" },
      { title: "Manager Name", dataKey: "ManagerName" },
      { title: "Sign", dataKey: "Sign" },

    ];
    var body = rows;
    // New Header and Footer Data Include the table
    var y = 5;
    pdf.setLineWidth(2);

    autoTable(pdf, {
      body: body,
      columns: columns,
      startY: 170,
      margin: {
        left: 10,
      },
      styles: { font: 'helvetica', overflow: "ellipsize", },

      // foot:[[' ', 'Price total', '130000', '  ']],
      headStyles: { textColor: [255, 255, 255], minCellHeight: 30, overflow: "linebreak", },
      footStyles: { textColor: [255, 255, 255], },

      theme: 'grid',
      columnStyles: {
        0: { halign: 'right', cellWidth: 30, },
        1: { halign: 'center', cellWidth: 70, },
        2: { halign: 'right', cellWidth: 60, },
        3: { halign: 'right', cellWidth: 60, },
        4: { halign: 'right', cellWidth: 60, },
        5: { halign: 'right', cellWidth: 60, },
        6: { halign: 'right', cellWidth: 60, },
        7: { halign: 'right', cellWidth: 100, },
        8: { halign: 'right', cellWidth: 70, },
      },
    })
    // pdf.output('dataurlnewwindow');  // commented on 20-03-2026 based on blank pdf on browser.
    // doc.save('Collection.pdf');  

    // The view logic
    const blob = pdf.output('blob')
    // create a temporary URL
    const url = URL.createObjectURL(blob);
    //open in a new tab(View Mode)
    const newWindow = window.open(url, '_blank');

    //safety check for pop-up blockers
    if(!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined'){
      alert('please disable your pop-up blocker to view the PDF.')
    }

    // We use a slight delay or wait for the window to unload
    if (newWindow) {
        newWindow.onload = () => {
            // Optional: Revoke after a delay to ensure Chrome has finished rendering
            setTimeout(() => {
                URL.revokeObjectURL(url);
                console.log("Memory cleared.");
            }, 1000);
    };
  }
}
}
